import React from 'react';
import { ZapIcon, CalendarCheckIcon, BarChart3Icon, FileTextIcon } from 'lucide-react';
type Feature = {
  icon: React.ReactNode;
  title: string;
  description: string;
  highlight?: string;
};
export function SolutionSection() {
  const features: Feature[] = [{
    icon: <ZapIcon className="w-8 h-8" strokeWidth={2} data-id="element-171" />,
    title: 'Instant Lead Response',
    description: 'Instantly respond to every new lead from Yelp, Meta, Google, and your website—24/7.',
    highlight: 'No more letting quote requests sit for hours while competitors scoop them up.'
  }, {
    icon: <CalendarCheckIcon className="w-8 h-8" strokeWidth={2} data-id="element-172" />,
    title: 'Guided Online Booking',
    description: 'Give every lead a clear path to book an estimate or consultation without back-and-forth.',
    highlight: 'Leads move straight from inquiry into your calendar and pipeline.'
  }, {
    icon: <BarChart3Icon className="w-8 h-8" strokeWidth={2} data-id="element-173" />,
    title: 'Simple Pipeline View',
    description: 'See every lead in one place: new, contacted, booked, follow-up, and closed.',
    highlight: 'Finally see what your ad spend is actually turning into in terms of jobs and revenue.'
  }, {
    icon: <FileTextIcon className="w-8 h-8" strokeWidth={2} data-id="element-174" />,
    title: 'Custom-Branded Invoicing',
    description: 'Send professional, branded invoices that match your company identity.',
    highlight: 'Track payments and keep billing tied to the same system that holds your leads and jobs.'
  }];
  return <section className="w-full bg-jet-black py-16 md:py-24 px-4 relative" data-id="element-175">
      {/* Angled top */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-white" style={{
      clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0 100%)'
    }} data-id="element-176" />

      <div className="max-w-6xl mx-auto pt-8" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <p className="text-viridia-green font-bold text-sm uppercase tracking-widest mb-4" data-id="element-179">
            The Four Pillars
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-180">
            Your{' '}
            <span className="text-viridia-green" data-id="element-181">Instant Lead Response</span>{' '}
            Growth Engine
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-182">
            Viridia captures every online lead, responds instantly, guides them
            to book, and gets you paid—all from one system built for
            contractors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-183">
          {features.map((feature, index) => <div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:border-viridia-green/50 transition-all duration-300 group" data-id="element-184">
              <div className="flex items-start gap-5" data-id="element-185">
                <div className="flex-shrink-0 w-14 h-14 bg-viridia-green rounded-xl flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300" data-id="element-186">
                  {feature.icon}
                </div>
                <div className="flex-1" data-id="element-187">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-188">
                    {feature.title}
                  </h3>
                  <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-3" data-id="element-189">
                    {feature.description}
                  </p>
                  {feature.highlight && <p className="text-sm md:text-base text-viridia-green font-semibold" data-id="element-190">
                      {feature.highlight}
                    </p>}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}